import ar_AE from './ar-AE';
import en from './en';
import fr from './fr';
import ms from './ms';
import pt_PT from './pt-PT';
import ta from './ta';
import zh from './zh';

const messages = { 'ar-AE': ar_AE, en, zh, ta, ms, fr, 'pt-PT': pt_PT };

export default messages;
